import React from 'react'

const VerticalCardTopLeft: React.FC = props => {
    return <>{props.children}</>
}

export default VerticalCardTopLeft
